import { SessionService as session } from "../services/SessionService";
import { useState } from "react";
import { isEmail, isName, isPhone } from "../services/validators";
import { useNavigate } from "react-router-dom";
import urls from "../config/urls.json";
import { isProd } from "../services/env";

export const useSession = () => {
    const navigate = useNavigate();
    const [r, ur] = useState(null);

    const update = (key, value) => {
        session.set(key, value);
        ur(new Date().getTime());
        // if(!isProd()) console.log(read());
    };

    const batchUpdate = (object) => {
        session.merge(object);
        ur(new Date().getTime());
        // if(!isProd()) console.log(read());
    };

    const read = (key) => {
        return session.get(key);
    };

    const getAppointmentPayload = () => {
        return session.getAppointmentPayload();
    };

    const getAppointmentNewPayload = () => {
        const oldPayload = session.getAppointmentPayload();
        return {
            codFiliale: oldPayload.filiale,
            data: oldPayload.data.split(" ")[0].replaceAll("-", ""),
            ricontatto: oldPayload.ricontatto || false,
            ora: oldPayload.data.split(" ")[1],
            datiCliente: {
                cellulare: oldPayload.cellulare,
                codiceFiscale: oldPayload.codiceFiscale,
                cognome: oldPayload.cognome,
                email: oldPayload.email,
                indirizzoResidenza: "",
                localitaNascita: "",
                localitaResidenza: "",
                nome: oldPayload.nome,
                privacyExtcommoffer: `${oldPayload.privacyExtcommoffer}`,
                privacyInterncommoffer: `${oldPayload.privacyInterncommoffer}`,
                privacyOtherservice: `${oldPayload.privacyOtherservice}`,
                privacyProfilazione: `${oldPayload.privacyProfilazione}`,
                tipoOccupazione: `${oldPayload.impiego}`,
                capResidenza: "",
                contactID: "",
                dataNascita: "",
                provinciaNascita: "",
                sesso: "",
                siglaProvinciaResidenza: "",
            },
            datiMediaUTM: {
                mediacode: oldPayload.mediacode,
                utmCampaign: oldPayload.utm_campaign,
                utmContent: oldPayload.utm_content,
                utmDate: oldPayload.utm_date,
                utmHistory: oldPayload.utm_history,
                utmMedium: oldPayload.utm_medium,
                utmSource: oldPayload.utm_source,
                utmTerm: oldPayload.utm_term,
                mediacodeInt: "",
            },
            prodottoLvl1: `${oldPayload.prodotto}`,
            gclId: oldPayload.gclid,
            clientId: oldPayload.clientId,
            IsForzosoClink: oldPayload.IsForzosoClink || false,
            oppID: "",
            prodottoLvl2: "",
            societa: "",
            utenteEsterno: "",
            utenteInterno: "",
            datiAggiuntivi: {
                agente: "",
                crm_i_id: "",
                durata: "",
                extReferrer: "",
                importo: "",
                prodottoOcs: "",
                rata: "",
                tabella: "",
                taeg: "",
                tan: "",
            },
            // serviceId: "",
            // companyType: {
            //     value: "",
            // },
        };
    };

    // const getClinkDirectAppointmentPayload = (codiceSubAgente, note) => {
    const getClinkDirectAppointmentPayload = (codiceSubAgente) => {
        const oldPayload = session.getAppointmentPayload();
        return {
            codiceSubAgente,
            // note,
            codFiliale: "",
            data: "",
            ora: "",
            oppID: "",
            prodottoLvl1: `${oldPayload.prodotto}`,
            prodottoLvl2: "",
            societa: "",
            utenteEsterno: "",
            utenteInterno: "",
            datiCliente: {
                capResidenza: "",
                cellulare: oldPayload.cellulare,
                codiceFiscale: oldPayload.codiceFiscale,
                cognome: oldPayload.cognome,
                contactID: "",
                dataNascita: "",
                email: oldPayload.email,
                indirizzoResidenza: "",
                localitaNascita: "",
                localitaResidenza: "",
                nome: oldPayload.nome,
                privacyExtcommoffer: `${oldPayload.privacyExtcommoffer}`,
                privacyInterncommoffer: `${oldPayload.privacyInterncommoffer}`,
                privacyOtherservice: `${oldPayload.privacyOtherservice}`,
                privacyProfilazione: `${oldPayload.privacyProfilazione}`,
                provinciaNascita: "",
                sesso: "",
                siglaProvinciaResidenza: "",
                tipoOccupazione: `${oldPayload.impiego}`,
            },
            datiMediaUTM: {
                mediacode: oldPayload.mediacode,
                mediacodeInt: "",
                utmCampaign: oldPayload.utm_campaign,
                utmContent: oldPayload.utm_content,
                utmDate: oldPayload.utm_date,
                utmHistory: oldPayload.utm_history,
                utmMedium: oldPayload.utm_medium,
                utmSource: oldPayload.utm_source,
                utmTerm: oldPayload.utm_term,
            },
            datiAggiuntivi: {
                agente: "",
                crm_i_id: "",
                durata: "",
                extReferrer: "",
                importo: "",
                prodottoOcs: "",
                rata: "",
                tabella: "",
                taeg: "",
                tan: "",
            },
        };
    };

    const isAppointmentPayloadReady = (weNeedFullPayload = true) => {
        document.querySelectorAll(".crea-appto-error").forEach((el) => {
            el.classList.add("hidden");
        });
        let isReady = true;
        const prodotto = read("prodotto") || 1;
        const requiredKeys = ["nome", "cognome", "email", "cellulare", "codiceFiscale", "privacyExtcommoffer", "privacyOtherservice", "privacyProfilazione"];
        if (prodotto == 1) {
            requiredKeys.push("filiale");
            requiredKeys.push("data");
            requiredKeys.push("privacyInterncommoffer");
        } else if (prodotto == 3) {
            requiredKeys.push("filiale");
            requiredKeys.push("data");
            requiredKeys.push("cap_utente");
            requiredKeys.push("tipoOccupazione");
        } else if (prodotto == 5) {
            requiredKeys.push("iscrittoCameraCommercio");
            requiredKeys.push("tipoAzienda");
            requiredKeys.push("comuneResidenza");
            requiredKeys.push("indirizzoResidenza");
            requiredKeys.push("privacyInterncommoffer");
        }
        let focusOn = "";
        let focusOnError = ".full-form-appto-error";
        let focusOnPosition = "center";

        const payload = getAppointmentPayload();

        for (let key of requiredKeys) {
            if (["privacyExtcommoffer", "privacyOtherservice", "privacyProfilazione"].includes(key) && (!payload.hasOwnProperty(key) || payload[key] == -1)) {
                isReady = false;
                focusOn = ".tos-list-component";
                focusOnPosition = "start";
                focusOnError = ".tos-list-component-appto-error";
                break;
            }
            if (["nome", "cognome"].includes(key) && (!payload[key] || !isName(payload[key]))) {
                isReady = false;
                focusOn = ".full-form";
                break;
            }
            if ("email" == key && (!payload[key] || !isEmail(payload[key].replace(".invalid", "")))) {
                isReady = false;
                focusOn = ".full-form";
                break;
            }
            if ("cellulare" == key && (!payload[key] || !isPhone(payload[key]))) {
                isReady = false;
                focusOn = ".full-form";
                break;
            }
            if (weNeedFullPayload && key == "privacyInterncommoffer" && (!payload[key] || payload[key] != "1")) {
                isReady = false;
                focusOn = ".tos-sic";
                focusOnError = ".tos-list-component-sic-appto-error";
                break;
            }
            if (!payload.hasOwnProperty(key)) {
                if (!weNeedFullPayload && "privacyInterncommoffer" == key) {
                    isReady = true;
                } else {
                    console.log(key + " Richiesta ma non presente");
                    isReady = false;
                }
                break;
            }

            if ("codiceFiscale" == key && payload["codiceFiscale"]) {
                payload["codiceFiscale"] = payload["codiceFiscale"].toUpperCase();
            }
        }

        if (focusOn.length) {
            let destinationNode = document.querySelector(focusOn);
            if (null != destinationNode) {
                destinationNode.scrollIntoView({
                    behavior: "smooth",
                    block: focusOnPosition,
                });
            }

            if (null != document.querySelector(`.crea-appto-error${focusOnError}`)) {
                document.querySelector(`.crea-appto-error${focusOnError}`).classList.remove("hidden");
            }
        }

        return isReady;
    };

    const isAppointmentPayloadAlmostReady = () => {
        return isAppointmentPayloadReady(false);
    };

    const canWeSkipLuogoPage = () => {
        return null != read("filialeScelta");
    };

    const setState = (state) => {
        update("state", state);
    };

    const isCompassQuintoSite = () => {
        return window.location.host.indexOf("compassquinto") != -1;
    };

    // handle browser back button
    const reloadAppOnBack = () => {
        window.addEventListener("popstate", (evt) => {
            evt.preventDefault();
            setState(0);
            window.location.href = `${window.location.origin}/${process.env.REACT_APP_FOLDER}`;
            return false;
        });
    };

    // basta che isAppointmentPayloadReady() sia true
    const canISkipAllPages = () => {
        return isAppointmentPayloadReady();
    };
    // puo arrivare all'ultima pagina prima di fissare,
    // ma deve seguire logiche di useCodiceFiscale:79 e :88
    const canISkipToLastPage = () => {};
    // deve avere filiali, filialescelta, etc per renderizzare slides
    // se c'è anche un codFiliale_external, deve spostare (con piccolo timeout) la splide delle subs
    //   per forzare cambio in data e orari
    const canISkipFirstPage = () => {};
    // basta che restituisca codicefiscale_external
    const canISkipCfPage = () => {
        return read("codiceFiscale_external");
    };

    const setC5 = () => {
        update("prodotto", 3);
        navigate(urls.codiceFiscaleC5.path);
    };

    const appendToPixelSteps = (steps) => {
        let currentSteps = read("pixelSteps") || [];
        update("pixelSteps", currentSteps.concat(steps));
    }

    return {
        update,
        batchUpdate,
        read,
        setState,
        getAppointmentPayload,
        isAppointmentPayloadReady,
        isAppointmentPayloadAlmostReady,
        reloadAppOnBack,
        canISkipAllPages,
        canISkipToLastPage,
        canISkipFirstPage,
        canISkipCfPage,
        canWeSkipLuogoPage,
        setC5,
        getAppointmentNewPayload,
        getClinkDirectAppointmentPayload,
        isCompassQuintoSite,
        appendToPixelSteps
    };
};
